module.exports = __webpack_public_path__ + "img/logo.d07df18a.svg";